<script>
import simplebar from "simplebar-vue";

import SideNav from "./side-nav";
import { layoutComputed } from "@/state/helpers";
import db from "@/firebase/init.js";
import "firebase/storage";

// From public/sounds (served at /sounds/alert4.mp3)
const alertSoundUrl = "/sounds/alert4.mp3";

/**
 * Sidebar component
 */
export default {
  components: { simplebar, SideNav },
  props: {
    isCondensed: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...layoutComputed,
    chatUnreadCount() {
      if (!this.users || !this.users.length) return 0;
      return this.users.reduce((total, u) => {
        const unread = (u.messages || []).filter((m) => m.isRead == false && m.idTo == 0).length;
        return total + unread;
      }, 0);
    },
  },
  data() {
    return {
      alertSoundUrl,
      settings: {
        minScrollbarLength: 60,
      },
      users: [],
      user: {},
      requests: [],
      previousRequestIds: JSON.parse(localStorage.getItem("previousRequestIds")) || [],
      previousChatUnreadByUser: {}, // user_id -> unread count, for new-message sound
      audioUnlocked: false, // set true after first user gesture so alert sound can play
      unread_alert: false,
      unread_title: false,
      current_user: {
        user_id: null,
        name: "",
        index: 0,
        email:"",
        mobile:"",
        country_code:"",
      },
    };
  },
  methods: {
    unlockAudio() {
      if (this.audioUnlocked) return;
      this.audioUnlocked = true;
      const el = this.$refs.alertSound;
      if (el) {
        el.play().then(() => { el.pause(); el.currentTime = 0; }).catch(() => {});
      }
    },
    playAlertSound() {
      const el = this.$refs.alertSound;
      if (!el) return;
      if (!this.audioUnlocked) return; // must unlock via user gesture first
      el.play().catch(() => {});
    },
    listenChatUsers() {  
        this.unread_alert = false;
        db.collectionGroup('messages').orderBy("timestamp", "desc")
        .onSnapshot((querySnapshot) => {  
          var users = [];
          querySnapshot.docs.forEach((doc) => {   
            var user = doc.data();

            db.collectionGroup(user.user_id.toString())
            .onSnapshot(snapshot => {
                user.messages = [];
                user.admin_unread = false;
                let unreadCount = 0;
                snapshot.docs.forEach((collection) => {
                  user.messages.push(collection.data());
                  if(collection.data().isRead == false && collection.data().idTo == 0) {
                    this.unread_alert = true;
                    user.admin_unread = true;
                    unreadCount++;
                  }
                });
                // Play sound when new chat message received (incoming unread)
                const prevUnread = this.previousChatUnreadByUser[user.user_id] || 0;
                if (unreadCount > prevUnread) {
                  this.playAlertSound();
                }
                this.previousChatUnreadByUser[user.user_id] = unreadCount;
                const itemIndex = users.findIndex(item => item.user_id === 
                      user.user_id);

                if (itemIndex !== -1) {
                      users[itemIndex] = user;
                } else {
                      users.push(user);
                }

                if (querySnapshot.docs.length === users.length) {
                  this.setUsers(users);
                }
            });            
       
          });
        });

    },

    fetchRequests(page_url = null) {
      this.getToken();
      let url = "api/admin/pharmacy/requestsnew"; 
      page_url = page_url || url;

      if (localStorage.back_url) {
        page_url = localStorage.back_url;  
        localStorage.removeItem('back_url');
      }

      this.loading = true;

      this.$axios.get(page_url, { headers: { Authorization: `Bearer ${this.token}` } })
        .then((res) => {
         
          const responseData = res.data.data;
          const newRequests = responseData.pharmacy_request;
          
          const newRequestIds = newRequests.map(request => request.id);
          
          const isNewRequestFound = newRequestIds.some(id => !this.previousRequestIds.includes(id));
          
          if (isNewRequestFound) {
            this.playAlertSound();
          }

          this.requests = newRequests;
          this.previousRequestIds = newRequestIds;

          localStorage.setItem('previousRequestIds', JSON.stringify(this.previousRequestIds));
          
        })
        .catch((error) => {
          console.error('Error occurred:', error);
          if (error.response) {
            const message = error.response.data.message;
            const displayMessage = typeof message === 'object' ? "Something went wrong" : message;
            this.$swal("", displayMessage, "error");
            console.log('Error message:', displayMessage);
          } else {
            this.$swal("", "Something went wrong", "error");
            console.log('Network or other error occurred.');
          }
        })
        .finally(() => {
          this.loading = false;
          console.log('Loading state set to false.');
        });
    },


    getToken() {
      if (localStorage.getItem('medicino_admin')) {
          var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
          if(medicino_admin.token) {
            this.token = medicino_admin.token;
          } else {
            this.$swal("", "Failed to fetch token, please login again", "error");
            this.$router.push({ name: "login" });
          }
          
      } else {
          this.$swal("", "Session expired, please login again", "error");
          this.$router.push({ name: "login" });
      }
    }, 


    setUsers(users) {
      this.users = users;
      console.log(this.users);
      this.current_user.user_id = this.users[0].user_id;
      this.current_user.name = this.users[0].name;
      this.current_user.index = 0;
    },

    onRoutechange() {
      setTimeout(() => {
        if(document.getElementsByClassName("mm-active").length > 0) {
        const currentPosition = document.getElementsByClassName("mm-active")[0].offsetTop;
        if (currentPosition > 500)
          this.$refs.currentMenu.SimpleBar.getScrollElement().scrollTop =
            currentPosition + 300;
        }
      }, 300);
    },
  },
  mounted() {
    this.listenChatUsers();
    this.fetchRequests();
    this.interval = setInterval(() => {
      this.listenChatUsers();
      this.fetchRequests();
    }, 300000);
    // Unlock audio on first user gesture (required by browser autoplay policy)
    const unlock = () => this.unlockAudio();
    document.addEventListener("click", unlock, { once: true });
    document.addEventListener("touchstart", unlock, { once: true });
  },

 beforeDestroy() {
    clearInterval(this.interval);  
  },
  created() {
    this.previousRequestIds = JSON.parse(localStorage.getItem('previousRequestIds')) || [];
    this.fetchRequests();
  },
  watch: {
    $route: {
      handler: "onRoutechange",
      immediate: true,
      deep: true,
    },
    users: {
      deep: true,
      handler() {
        // New chat message sound is played in listenChatUsers when unread count increases
      }
  },

    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "dark":
              document.body.setAttribute("data-sidebar", "dark");
              document.body.removeAttribute("data-topbar");
              document.body.removeAttribute("data-sidebar-size");
              document.body.removeAttribute("data-keep-enlarged");
              document.body.classList.remove("vertical-collpsed");
              break;
            case "light":
              document.body.setAttribute("data-topbar", "dark");
              document.body.removeAttribute("data-sidebar");
              document.body.removeAttribute("data-sidebar-size");
              document.body.classList.remove("vertical-collpsed");
              break;
            case "compact":
              document.body.setAttribute("data-sidebar-size", "small");
              document.body.setAttribute("data-sidebar", "dark");
              document.body.classList.remove("vertical-collpsed");
              document.body.removeAttribute("data-topbar", "dark");
              break;
            case "icon":
              document.body.setAttribute("data-keep-enlarged", "true");
              document.body.classList.add("vertical-collpsed");
              document.body.setAttribute("data-sidebar", "dark");
              document.body.removeAttribute("data-topbar", "dark");
              break;
            case "colored":
              document.body.setAttribute("data-sidebar", "colored");
              document.body.removeAttribute("data-keep-enlarged");
              document.body.classList.remove("vertical-collpsed");
              document.body.removeAttribute("data-sidebar-size");
              break;
            default:
              document.body.setAttribute("data-sidebar", "dark");
              break;
          }
        }
      },
    },
    width: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "boxed":
              document.body.setAttribute("data-layout-size", "boxed");
              document.body.removeAttribute("data-layout-scrollable");
              break;
            case "fluid":
              document.body.setAttribute("data-layout-mode", "fluid");
              document.body.removeAttribute("data-layout-size");
              document.body.removeAttribute("data-layout-scrollable");
              break;
            case "scrollable":
              document.body.setAttribute("data-layout-scrollable", "true");
              document.body.removeAttribute("data-layout-mode");
              document.body.removeAttribute("data-layout-size")
              break;
            default:
              document.body.setAttribute("data-layout-mode", "fluid");
              break;
          }
        }
      },
    },
  },
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->
  <div class="vertical-menu">
   <audio ref="alertSound" :src="alertSoundUrl" preload="auto"></audio>
    <simplebar
      v-if="!isCondensed"
      :settings="settings"
      class="h-100"
      ref="currentMenu"
      id="my-element"
    >
      <SideNav :chatUnreadCount="chatUnreadCount" />
    </simplebar>

    <simplebar v-else class="h-100">
      <SideNav :chatUnreadCount="chatUnreadCount" />
    </simplebar>
  </div>
  <!-- Left Sidebar End -->
</template>

